
import {defineComponent} from '@nuxtjs/composition-api';
export default defineComponent({
    props: ['error'],
    setup(){
      const toggleMessage = () => {
        const msgEl = <HTMLElement>document.body.querySelector('.message')
        if(msgEl.classList.contains('hidden')) { msgEl.classList.remove('hidden') }
        else { msgEl.classList.add('hidden') }
      }
      return{
        toggleMessage
      }
    },
})
